import { Box, Typography } from '@mui/material';
import ReactJson from 'react-json-view';
import React, { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

export const JsonViewer = ({ withAvatar = false, content, showAvatar, type }) => {
  const [showTable, setShowTable] = useState(false);
  let data = {};
  try {
    data = JSON.parse(content);
  } catch (e) {
    return <div>Invalid JSON</div>;
  }

  return (
    <Box
      sx={{
        pl: withAvatar && !showAvatar ? '65px' : 0,
        display: 'flex',
        flexDirection: 'row',
        my: 1,
      }}
    >
      <Box
        sx={{
          border: '1px solid lightgray',
          padding: withAvatar ? '8px 14px' : '8px 12px',
          maxWidth: withAvatar ? '75%' : '85%',
          borderRadius: '8px',
          backgroundColor: '#fafafa',
          boxShadow: 1,
        }}
      >
        <Box
          onClick={() => setShowTable(!showTable)}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            cursor: 'pointer',
            userSelect: 'none',
            // width: '100%',
          }}
        >
          <Typography variant="subtitle1" fontWeight="bold">
            {type}
          </Typography>
          <span>{showTable ? <ExpandLessIcon /> : <ExpandMoreIcon />}</span>
        </Box>

        {showTable && (
          <Box sx={{ overflowX: 'auto', mt: 1 }}>
            {withAvatar ? (
              <ReactJson src={data} collapsed={2} theme="rjv-default" enableClipboard={false} />
            ) : (
              <ReactJson
                src={data}
                collapsed={2}
                theme="rjv-default"
                enableClipboard={false}
                displayDataTypes={false}
                displayObjectSize={false}
                name={false}
              />
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
};
